export class GetSettingsAction {
    static readonly type = "[Params] Get all app settings";
  }
  